import Vue from 'vue'
import numeral from 'numeral'
import axiosSetting from "./axiosSetting";
class Helper {
	constructor (){

	}

	throttle (fn, wait){
		let time = Date.now();
		return function(){
			if ((time + wait - Date.now()) < 0) {
				fn();
				time = Date.now();
			}
		}
	}


	clone (obj,deep=true){
		if(typeof obj !== 'object'){
			return obj;
		}
		if(deep){
			if(Array.isArray(obj)){
				let cloneObj = [];
				for(let [,o] of obj.entries()){
					cloneObj.push(this.clone(o,true));
				}
				return cloneObj;
			}else{
				let cloneObj = {}
				for(let k in obj){
					if(Array.isArray(obj[k])){
						let a = []
						for(let i=0;i<obj[k].length;i++){
							a.push(this.clone(obj[k][i],true))
						}
						cloneObj[k] = a;
					}else if(typeof obj[k] !== 'object'){
						cloneObj[k] = obj[k];
					}else{
						cloneObj[k] = this.clone(obj[k],true);
					}
				}
				return cloneObj;
			}
		}else{
			if(Array.isArray(obj)){
				return [].concat(obj);
			}else{
				return Object.assign({},obj);
			}
		}
	}
	//搜狗浏览器上面
	// 如果在template直接用Object.entries就报错
	// 真的是日了狗了
	entries (obj){
		return Object.entries(obj)
	}
	values (obj){
		return Object.values(obj);
	}
	isEmptyObj (obj){
		for(let key in obj){
			if(obj[key]){
				return false
			}
		}
		return true;
	}
	getDefaultStyle (obj,attribute){
		return obj.currentStyle?obj.currentStyle[attribute]:document.defaultView.getComputedStyle(obj,false)[attribute];
	}
	getOffset (node){
		function getParentOffset(node){
			let left = node.offsetLeft || 0;
			let top = node.offsetTop || 0;
			if(node.offsetParent){
				let offset = getParentOffset(node.offsetParent);
				left += offset.left;
				top += offset.top;
			}
			return {
				left,top
			}
		}
		return getParentOffset(node)
	}

	extendData (target,...cloneObj){
		let clone = (out,obj)=>{
			out = out || {};
			if (!obj){

			}else{
				for(let key in obj) {
					if(obj.hasOwnProperty(key)){
						if(Array.isArray(obj[key])){
							out[key] = (out[key] || []).concat([obj[key]]);
						}else if(typeof obj[key] === 'object'){
							out[key] = clone(out[key], obj[key]);
						}
						else{
							out[key] = obj[key];
						}
					}
				}
			}
			return out;
		}
		for(let [,o] of cloneObj.entries()){
			target = clone(target,o);
		}
		return target;
	}

	getFormData (form = {}){
		let data = {};
		for(let key in form){
			if(typeof form[key] === 'object' && 'rules' in form[key] && 'domValue' in form[key]){
				data[key] = form[key]['domValue'];
			}else{
				data[key] = form[key];
			}
		}
		return this.removeEmptyPro(data);
	}

	removeEmptyPro (form){
		for(let v in form){
			if(form[v] === ''){
				delete form[v];
			}
		}
		return form;
	}

	initForm (form={}){
		let init = (obj)=>{
			if(typeof obj !== 'object'){
				return '';
			}
			if(Array.isArray(obj)){
				return []
			}
			for(let key in obj){
				if(typeof obj[key] === 'object'){
					if('domValue' in obj[key]){
						obj[key].domValue = '';
					}else{
						obj[key] = init(obj[key]);
					}
				}else{
					obj[key] = '';
				}
			}
			return obj;
		}
		return init(form);
	}

	getDate (timeStamp = new Date().getTime(),splitSymble = '-',disDay = 0){
		if(typeof timeStamp === 'string'){
			timeStamp = timeStamp.replace(/-/g,'/');
		}
		let date = new Date(new Date(timeStamp).getTime() - disDay*24*60*60*1000);
		let beauty = (num)=>{
			return num > 9 ? num : '0' + num;
		}
		return date.getFullYear() + splitSymble + beauty(date.getMonth()+1) + splitSymble + beauty(date.getDate());
	}

	getTimeDetail (timeStamp = new Date().getTime(),splitSymble = '-'){
		if(typeof timeStamp === 'string'){
			timeStamp = timeStamp.replace(/-/g,'/');
		}
		let date = new Date(timeStamp);
		let beauty = (num)=>{
			return num > 9 ? num : '0' + num;
		}
		return beauty(date.getHours()) + splitSymble + beauty(date.getMinutes()) + splitSymble + beauty(date.getSeconds());
	}

	setContainerFullHeight ($container = document.querySelectorAll('.container')[1]){
		let _height = document.body.clientHeight - document.querySelectorAll('.container')[0].clientHeight;
		$container.style.minHeight = _height+'px';
	}

	ossParam({width='',height='', m='', limit=1, hasWatermark=false}={width : 320,height : 320, m : '', limit : 1, hasWatermark:false},extraParam = ''){
		let p = hasWatermark ? '/resize' : '?x-oss-process=image/resize';
		if(m) {
			p += ',m_' + m;
		}
		if(height){
			p += ',h_' + height;
		}
		if(width){
			p += ',w_' + width;
		}
		if(limit === 0 || limit === 1){
			p += ',limit_' + limit;
		}
		p += extraParam
		return p
	}

	printArea (id){
		if(!id){
			return
		}
		let el = document.getElementById(id);
		let iframe = document.createElement('iframe');
		let doc = null;
		iframe.setAttribute('style','position:absolute;width:0;height:0,left:-9999px');
		document.body.appendChild(iframe);
		doc = iframe.contentWindow.document;
		doc.write('<div>' + el.innerHTML + '</div>');
		doc.close();
		iframe.contentWindow.focus();
		iframe.contentWindow.print();
	}

	test (){
		// console.log('helper loaded',p);
		return 'xxx';
	}

	dateFormat (timeStamp,fmt){ //author: meizz
		let timeObj = new Date(parseInt(timeStamp)*1000);
		let o = {
			"M+" : timeObj.getMonth()+1,                 //月份
			"d+" : timeObj.getDate(),                    //日
			"h+" : timeObj.getHours(),                   //小时
			"m+" : timeObj.getMinutes(),                 //分
			"s+" : timeObj.getSeconds(),                 //秒
			"q+" : Math.floor((timeObj.getMonth()+3)/3), //季度
			"S" : timeObj.getMilliseconds()             //毫秒
		};
		if(/(y+)/.test(fmt))
			fmt=fmt.replace(RegExp.$1, (timeObj.getFullYear()+"").substr(4 - RegExp.$1.length));
		for(var k in o)
			if(new RegExp("("+ k +")").test(fmt))
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length===1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		return fmt;
	};
	//上传
	upload(base64Data){
		return new Promise((resolve,reject)=>{
			if(!!base64Data){
				let formData = new FormData();
				formData.append('file',base64Data);
				axiosSetting.AxiosIns({
					method : 'post',
					url : 'upload/image.json',
					headers : {
						'Content-Type' : 'multipart/form-data'
					},
					data : formData
				}).then((res)=>{
					resolve(res);
				}).catch((e)=>{
					reject(e);
				});
			}
		});
	}
	/**
	 * 格式化-千分位
	 * @param {*} money
	 * @returns
	 */
	formatMoney(money,isShowEmpty = false) {
		if (money === '' && isShowEmpty) {
			return money;
		}
		if (String(money).indexOf('*') >= 0) {
			return money;
		}
		const m = parseFloat(money);
		let length = String(m).split('.')[1] ? String(m).split('.')[1].length : 0;
		let format = '0,0';
		switch (length) {
		case 1:
			format = '0,0.0';
			break;
		case 2:
		case 3:
			format = '0,0.00';
			break;
		default:
			format = '0,0';
			break;
		}
		return numeral(m).format(format);
	}
}
Helper.prototype.numeral = numeral;
let helper = new Helper();
Vue.prototype.Helper = helper;
export default helper;



// WEBPACK FOOTER //
// ./src/common/Helper.js